import useSettings from '@/components/shared/map/layer-selector/use-settings'
import { useSettingsSelector } from './use-settings-selector'
import type { ISettings } from './settings.interface'

export function useNavigationDemo(): ISettings['navigationDemo'] {
  const { data } = useSettings()
  const embedded = useSettingsSelector((settings) => settings.navigationDemo)

  return data?.navigationDemo ?? embedded
}
